import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutSuccess } from "../services/auth";
import { APP_URL } from "../util/constants/APP_URL";

interface ModalProps {
    onClose: VoidFunction
}

export const ModalLogout = ({ onClose } : ModalProps) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
  
    
    const logout = () => {
        dispatch(logoutSuccess())
        navigate(APP_URL.AUTHENTICATION.LOGIN)
    }

    return (
        <div className="modal">
            <div className="modal-body modal-logout-body">
               <div>
                <p className="ft-EricssonGA628">¿Cerrar sesión?</p>
                <div className="option-group ft-EricssonGA628">
                    <div>
                        <p onClick={logout} className="option confirm">Sí</p>
                    </div>
                    <div>
                        <p onClick={onClose} className="option cancel">No</p>
                    </div>
                </div>
               </div>
            </div>
        </div>
    )
}